var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin"},[_c('b-container',[_c('div',{staticClass:"section-content"},[_c('breadcrumb'),_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }